import {combineReducers} from "redux";

import ratesReducer, {NAME as rates} from './ratesReducer';
import etherollReducer, {NAME as etheroll} from './etherollReducer';

export default combineReducers({
    [rates]: ratesReducer,
    [etheroll]: etherollReducer,
});